import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { toast } from 'sonner';
import MorseCodeVisualizer from './MorseCodeVisualizer';

export default function ProductCard({ product }) {
  const { addToCart, loading } = useCart();

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const success = await addToCart(product.id);
    if (success) {
      toast.success(`${product.name} added to cart`);
    } else {
      toast.error('Failed to add to cart');
    }
  };

  return (
    <Link 
      to={`/products/${product.id}`}
      className="group block"
      data-testid={`product-card-${product.id}`}
    >
      <div className="product-card">
        {/* Image Container */}
        <div className="relative overflow-hidden bg-[#F5F5F0] rounded-sm">
          <img
            src={product.image}
            alt={
              product.category === 'pocket-stone'
                ? `${product.name} — polished natural stone from Whispering Wristwear, Paphos`
                : `${product.name} — handmade Morse code bracelet${product.morse_text ? ` spelling "${product.morse_text.toLowerCase()}"` : ''} · Whispering Wristwear`
            }
            className="product-image"
            loading="lazy"
          />
          
          {/* Quick Add Button */}
          <button
            onClick={handleAddToCart}
            disabled={loading}
            className="absolute bottom-4 right-4 p-3 bg-[#FAF9F6] rounded-full shadow-float opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-[#354F52] hover:text-[#FAF9F6]"
            data-testid={`add-to-cart-${product.id}`}
          >
            <ShoppingBag className="w-5 h-5" strokeWidth={1.5} />
          </button>

          {/* Featured Badge */}
          {product.featured && (
            <div className="absolute top-4 left-4">
              <span className="text-caption text-[#D4AF37] bg-[#FAF9F6] px-3 py-1.5 rounded-full text-xs">
                Bestseller
              </span>
            </div>
          )}
        </div>

        {/* Product Details */}
        <div className="product-details mt-6">
          <h3 className="font-serif text-lg text-[#354F52] mb-1">
            {product.name}
          </h3>
          
          {/* Mini Morse Preview */}
          <div className="flex items-center justify-center gap-1 my-2">
            <MorseCodeVisualizer text={product.morse_text} size="sm" />
          </div>
          
          <p className="text-[#D4AF37] font-medium" data-testid="product-card-price">
            <span className="text-xs text-[#84A98C] mr-1 font-normal">From</span>
            €{product.price.toFixed(2)}
          </p>
        </div>
      </div>
    </Link>
  );
}
